import React from 'react';
import AsciiDonut from '../components/AsciiDonut';

const SOCIAL_LINKS = [
  {
    name: 'GitHub',
    href: 'https://github.com/GuilhermePortella',
    description: 'Codigo aberto, repos e exploracoes tecnicas.',
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/myprofileguilhermeportella/',
    description: 'Networking profissional e conversa sobre carreira.',
  },
  {
    name: 'Twitter/X',
    href: 'https://x.com/BYTE_GHOST404',
    description: 'Ideias rapidas sobre tech e desenvolvimento.',
  },
];

const Contato = () => {
  return (
    <>
      <section className="site-bg-hero py-16 px-6">
        <div className="container mx-auto max-w-4xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-blue-600">Contato</p>
          <h1 className="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Vamos conversar sobre sua proxima ideia
          </h1>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-gray-600">
            Se voce quer tirar um projeto do papel, discutir tecnologia ou trocar experiencias de
            carreira, esta pagina e o melhor ponto de partida.
          </p>
        </div>
      </section>

      <section className="site-bg-section py-16 px-6">
        <div className="container mx-auto">
          <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:items-start">
            <div className="space-y-6">
              <article className="rounded-3xl border border-gray-200 bg-white p-7 shadow-lg site-card">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-600">
                  Canal principal
                </p>
                <h2 className="mt-2 text-2xl font-bold tracking-tight text-gray-900">
                  Vamos por email
                </h2>
                <a
                  href="mailto:guilhermeportella.dev@gmail.com"
                  className="mt-4 inline-block break-all text-xl font-semibold text-blue-700 hover:underline"
                >
                  guilhermeportella.dev@gmail.com
                </a>
                <p className="mt-3 text-sm leading-7 text-gray-600">
                  Respondo melhor por email para conversas de projeto, parcerias e networking.
                  Normalmente retorno em ate 24h.
                </p>
                <a
                  href="mailto:guilhermeportella.dev@gmail.com"
                  className="mt-5 inline-flex rounded-full border border-blue-200 bg-blue-100/80 px-4 py-2 text-sm font-semibold text-blue-800 transition hover:bg-blue-200"
                >
                  Enviar mensagem
                </a>
              </article>

              <article className="rounded-3xl border border-gray-200 bg-gray-50 p-7 shadow-sm site-card-soft">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-500">
                  Conversa rapida
                </p>
                <h2 className="mt-2 text-xl font-semibold text-gray-900">Redes sociais</h2>
                <div className="mt-5 grid gap-3 sm:grid-cols-2">
                  {SOCIAL_LINKS.map((link) => (
                    <a
                      key={link.name}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rounded-2xl border border-gray-200 bg-white p-4 transition hover:border-blue-200 hover:shadow-sm"
                    >
                      <p className="text-sm font-semibold text-gray-900">{link.name}</p>
                      <p className="mt-1 text-xs leading-5 text-gray-600">{link.description}</p>
                    </a>
                  ))}
                </div>
              </article>

              <article className="rounded-3xl border border-blue-100 bg-blue-50/70 p-7">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-700">
                  Disponibilidade
                </p>
                <p className="mt-2 text-sm leading-7 text-blue-900">
                  Aberto para freelas pontuais, colaboracoes de codigo aberto e conversas sobre
                  oportunidades de backend e produtos digitais.
                </p>
              </article>
            </div>

            <div className="flex justify-center lg:justify-start">
              <AsciiDonut size="expanded" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contato;
